// Footer-v1.0.0.jsx - Version: 1.0.0 - Created: 2024-12-08
import React from 'react'
import './Footer-v1.0.0.css'

const Footer = () => {
  return (
    <footer className="footer-v1">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-placeholder">♛</div>
              <span className="logo-text">Chess4Kids.ir</span>
            </div>
            <p className="footer-description">
              پلتفرم آموزشی شطرنج برای کودکان ۶ تا ۱۲ سال
              <br />
              یادگیری آسان، سریع و لذت‌بخش
            </p>
          </div>

          <div className="footer-section">
            <h4>دسترسی سریع</h4>
            <ul className="footer-links">
              <li><a href="#home">صفحه اصلی</a></li>
              <li><a href="#academy">آکادمی شطرنج</a></li>
              <li><a href="#play">زمین بازی</a></li>
              <li><a href="#practice">باشگاه تمرین</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>لینک‌های مفید</h4>
            <ul className="footer-links">
              <li><a href="#parents">بخش والدین</a></li>
              <li><a href="#about">درباره ما</a></li>
              <li><a href="#contact">تماس با ما</a></li>
              <li><a href="#faq">سوالات متداول</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>تماس با ما</h4>
            <div className="contact-info">
              <p>📧 info@chess4kids.ir</p>
              <p>📱 ۰۹۱۲XXX‌XXXX</p>
              <div className="social-links">
                <a href="#" aria-label="Instagram">📸</a>
                <a href="#" aria-label="Telegram">📢</a>
                <a href="#" aria-label="YouTube">🎬</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© ۲۰۲۴ Chess4Kids.ir - کلیه حقوق محفوظ است</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer